import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on, Action } from '@ngrx/store';

import * as VerifyUserIdentityActions from './verify-user-identity.actions';
import { VerifyUserIdentityEntity } from './verify-user-identity.models';

export const VERIFY_USER_IDENTITY_FEATURE_KEY = 'verifyUserIdentity';

export interface VerifyUserIdentityState {
  loaded: boolean; // has the VerifyUserIdentity been loaded
  loading: boolean; // has the VerifyUserIdentity been loading
  identityVerified: boolean; // has the VerifyUserIdentity been verified
  identityVerifiedAt: Date | null;
  error?: string | null; // last known error (if any)'
  // The action object used in the verifyUserIdentity reducer.
  action?: {
    data?: any;
    key: string;
  };
}

export interface VerifyUserIdentityPartialState {
  readonly [VERIFY_USER_IDENTITY_FEATURE_KEY]: VerifyUserIdentityState;
}

export const initialVerifyUserIdentityState: VerifyUserIdentityState = {
  // set initial required properties
  loaded: false,
  loading: false,
  identityVerified: false,
  identityVerifiedAt: null,
};

const reducer = createReducer(
  initialVerifyUserIdentityState,
  on(VerifyUserIdentityActions.initVerifyUserIdentity, (state) => ({
    ...state,
    identityVerified: false,
    identityVerifiedAt: null,
    loaded: false,
    loading: true,
    error: null,
  })),

  on(VerifyUserIdentityActions.loadVerifyUserIdentitySuccess, (state) => ({
    ...state,
    identityVerified: true,
    identityVerifiedAt: new Date(),
    loaded: true,
    loading: false,
  })),
  on(
    VerifyUserIdentityActions.loadVerifyUserIdentityFailure,
    (state, { error }) => ({
      ...state,
      error,
      identityVerified: false,
      loading: false,
    }),
  ),
  on(VerifyUserIdentityActions.openVerifyUserIdentity, (state, { action }) => ({
    ...state,
    action,
    identityVerified: true,
    loaded: true,
  })),
);

export function verifyUserIdentityReducer(
  state: VerifyUserIdentityState | undefined,
  action: Action,
) {
  return reducer(state, action);
}
